/** Internal helper imports here ... */
import { forEach } from 'lodash'

/**
 * Module description...
 *
 * @returns {{init: init}}
 */
export default (() => {
  /**
   * Other functions...
   */

  const init = () => {
    const checkBoxSelector = '.tumblestoneNavigationHamburger';

    const tumblestoneHamburger = document.querySelectorAll(checkBoxSelector);
    const tumblestoneNavigationBackground = document.querySelector('.tumblestoneNavigationBackground');
    const tumblestoneNavigation = document.querySelector('.tumblestoneNavigation');

    const toggle = (element) => {
      element.classList.toggle('show');
    };

    forEach(tumblestoneHamburger, (hamburger) => {
      hamburger.addEventListener('click', () => {
        toggle(tumblestoneNavigationBackground);
        toggle(tumblestoneNavigation);
      });
    });
  };

  return {
    init,
  };
})();
